<template>
  <div class="camera_outer">
    <video id="videoCamera" class="video-frame" :width="videoWidth" :height="videoHeight" autoplay></video>
    <canvas style="display:none;" id="canvasCamera" :width="videoWidth" :height="videoHeight"></canvas>
  </div>
</template>

<script>
import { qiniuUpload } from '@/utils'
export default {
  props: {
    videoWidth: {
      type: Number
    },
    videoHeight: {
      type: Number
    },
    photoWidth: {
      type: Number
    },
    photoHeight: {
      type: Number
    },
    uploadPath: {
      type: String
    }
  },
  data() {
    return {
      thisCanvas: null,
      thisContext: null,
      thisVideo: null
    }
  },
  methods: {
    // 调用权限（打开摄像头功能）
    getCompetence() {
      const _this = this
      this.thisCanvas = document.getElementById('canvasCamera')
      this.thisContext = this.thisCanvas.getContext('2d')
      this.thisVideo = document.getElementById('videoCamera')
      // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {}
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function (constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) { // 浏览器不支持
            // getUserMedia is not implemented in this browser
            return Promise.reject(new Error('a'))
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function (resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject)
          })
        }
      }
      const constraints = {
        // audio: false,
        // video: { width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)' }
        video: true
      }
      navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
        // 旧的浏览器可能没有srcObject
        if ('srcObject' in _this.thisVideo) {
          _this.thisVideo.srcObject = stream
        } else {
          // 避免在新的浏览器中使用它，因为它正在被弃用。
          _this.thisVideo.src = window.URL.createObjectURL(stream)
        }
        _this.thisVideo.onloadedmetadata = function (e) {
          _this.thisVideo.play()
        }
        _this.$emit('openVideo')
      }).catch(err => { // 捕获错误
        console.log('getUserMedia', err)
        this.handleCameraError(err)
      })
    },
    // 绘制图片（拍照功能）
    async setImage() {
      const _this = this
      // 点击，canvas画图
      _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.photoWidth, _this.photoHeight)
      // 获取图片base64链接
      const image = this.thisCanvas.toDataURL('image/png')
      // base64转文件
      const file = this.base64ImgtoFile(image)
      // 上传七牛云
      let imgUrl = ''
      if (this.uploadPath) {
        imgUrl = await qiniuUpload(file, { path: this.uploadPath })
      } else {
        imgUrl = await qiniuUpload(file)
      }
      this.$emit('photoReport', imgUrl)
    },
    // base64转文件
    base64ImgtoFile(dataurl, filename = 'cameraImg') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    // 关闭摄像头
    stopNavigator() {
      if (this.thisVideo.srcObject) {
        this.thisVideo.srcObject.getTracks()[0].stop()
      }
    },
    handleCameraError(err) {
      console.log(`${err.name}: ${err.message}`)
      let errorType = ''
      switch (err.name) {
        case 'NotAllowedError':
          errorType = 'b'
          break
        case 'OverConstrainedError':
          errorType = 'c'
          break
        case 'NotFoundError':
          errorType = 'd'
          break
        case 'AbortError':
          errorType = 'f'
          break
        default:
          errorType = 'g'
          break
      }
      this.$emit('handleError', errorType)
    }
  },
  destroyed() {
    this.stopNavigator()
  }
}
</script>

<style lang="scss" scoped>
  .camera_outer{
    position: relative;
    overflow: hidden;
    background-size: 100%;
    video,canvas,.tx_img{
      -moz-transform:scaleX(-1);
      -webkit-transform:scaleX(-1);
      -o-transform:scaleX(-1);
      transform:scaleX(-1);
    }
    img {
      width: 100px;
    }
  }
  .video-frame {
    object-fit:fill;
  }
</style>
